<template>
  <v-layout justify-center>
    <v-dialog v-model="dialog" max-width="600px" @keydown.esc="$emit('closeDialog')" :persistent="true">
      <template v-slot:activator="{ on }" v-if="addBtn">
        <v-btn color="#0e9e98de" dark small absolute top right fab v-on="on">
          <v-icon>add</v-icon>
        </v-btn>
      </template>
      <v-card>
        <v-card-title>
          <span class="headline">Registrar Transação</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <span class="subheading" v-if="bankAccountReadOnly">{{selectedBankAccount}}</span>
                <v-autocomplete
                  clearable
                  :placeholder="i18n('Pesquise pelo número da conta ou apelido')"
                  @click:clear="clearAutocomplete"
                  :no-data-text="noDataText"
                  v-on:keyup.enter="findBankAccountByNumberOrNickname($event)"
                  v-model="bank_account_id"
                  :errorMessages="errorMessagesFor('main_activity')"
                  :items="bankAccountItems"
                  label="Conta"
                  v-if="!bankAccountReadOnly"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field
                  label="Data"
                  v-model="movement_date_formatted"
                  background-color="white"
                  mask="##/##/####"
                  :return-masked-value=true
                  hint="DD/MM/YYYY"
                  :errorMessages="errorMessagesFor('movement_date')"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-currency-field
                  label="Valor"
                  v-model="value"
                  v-bind="currency_config"
                  :errorMessages="errorMessagesFor('value')"
                  background-color="white"
                ></v-currency-field>
              </v-flex>
              <v-flex xs12 sm3>
                <v-select label="Tipo documento" v-model="source_document_type"
                  :items="[{text: 'CPF', value: 'cpf'}, {text: 'CNPJ', value: 'cnpj'}, {text: 'Passaporte', value: 'passport'}, {text: 'Tax ID', value: 'tax_id'}, {text: 'CURP', value: 'curp'}, {text: 'RFC', value: 'rfc'}, {text: 'CC', value: 'cc'}, {text: 'NIT', value: 'nit'}, {text: 'RUT', value: 'rut'}]"
                  :errorMessages="errorMessagesFor('source_document_type')"
                  required
                ></v-select>
              </v-flex>
              <v-flex xs12 sm9>
                <v-text-field label="CPF" mask="###.###.###-##" v-model="source_document_number" :errorMessages="errorMessagesFor('source_document_number')" required v-if="selectedDocumentType == 'cpf'"></v-text-field>
                <v-text-field label="CNPJ" v-model="source_document_number" :errorMessages="errorMessagesFor('source_document_number')" required v-if="selectedDocumentType == 'cnpj'"></v-text-field>
                <v-text-field label="Passaporte" v-model="source_document_number" :errorMessages="errorMessagesFor('source_document_number')" required v-if="selectedDocumentType == 'passport'"></v-text-field>
                <v-text-field label="Tax ID" v-model="source_document_number" :errorMessages="errorMessagesFor('source_document_number')" required v-if="selectedDocumentType == 'tax_id'"></v-text-field>
                <v-text-field label="CURP" mask="AAAA######AAAAAANN" v-model="source_document_number" :errorMessages="errorMessagesFor('source_document_number')" required v-if="selectedDocumentType == 'curp'"></v-text-field>
                <v-text-field label="RFC" mask="AAAN#####NNNN" v-model="source_document_number" :errorMessages="errorMessagesFor('source_document_number')" v-if="selectedDocumentType == 'rfc'"></v-text-field>
                <v-text-field label="CC" mask="##########" v-model="source_document_number" :errorMessages="errorMessagesFor('source_document_number')" v-if="selectedDocumentType == 'cc'"></v-text-field>
                <v-text-field label="NIT" mask="###.###.###-#" v-model="source_document_number" :errorMessages="errorMessagesFor('source_document_number')" v-if="selectedDocumentType == 'nit'"></v-text-field>
                <v-text-field label="RUT" mask="##.###.###-N" v-model="source_document_number" :errorMessages="errorMessagesFor('source_document_number')" v-if="selectedDocumentType == 'rut'"></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field label="Nome" v-model="source_name" :errorMessages="errorMessagesFor('source_name')" required :disabled="sourceNameDisabled"></v-text-field>
              </v-flex>
              <v-flex xs12 sm4 md4>
                <v-text-field label="Banco Origem" v-model="source_bank" :errorMessages="errorMessagesFor('source_bank')" hint="Ex: 001" required></v-text-field>
              </v-flex>
              <v-flex xs12 sm4 md4>
                <v-text-field label="Agência Origem" v-model="source_branch" :errorMessages="errorMessagesFor('source_branch')" required ></v-text-field>
              </v-flex>
              <v-flex xs12 sm4 md4>
                <v-text-field label="Conta Origem" v-model="source_account" :errorMessages="errorMessagesFor('source_account')" required></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-radio-group v-model="source_type">
                  <div slot="label">Forma de pagamento</div>
                  <div class="account-type">
                    <v-radio label="PIX" value="PIX"></v-radio>
                    <v-radio label="TED" value="TED"></v-radio>
                    <v-radio label="SPEI" value="SPEI"></v-radio>
                    <v-radio label="PSE" value="PSE"></v-radio>
                    <v-radio label="PCT (Chile)" value="PCT"></v-radio>
                    <v-radio label="WIRE" value="WIRE"></v-radio>
                  </div>
                </v-radio-group>
              </v-flex>
              <v-flex xs6 md4>
              <v-text-field
                  label="Referência numérica"
                  v-if="source_type == 'SPEI'"
                  v-model="spei_reference"
                  background-color="white"
                  mask="#######"
                  :errorMessages="errorMessagesFor('spei_reference')"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 md8>
              <v-text-field
                  label="Concepto de Pago"
                  v-if="source_type == 'SPEI'"
                  v-model="spei_concepto_de_pago"
                  background-color="white"
                  :errorMessages="errorMessagesFor('spei_concepto_de_pago')"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="ma-0 btn-style--gray mr-2" block dark @click="$emit('closeDialog')">Voltar</v-btn>
          <v-btn class="ma-0 btn-style--secondary" block dark @click="createBankTransaction">Registrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import utils from "./shared/Utils"
import { BankAccountsApi } from '@/shared/BankAccountsApi'

export default {
  name: 'BankTransactionAddFormDialog',
  props: {
    addBtn: {
      type: Boolean,
      default: true
    },
    autocomplete: {
      type: Object,
      default: () => {
        return {
          source_document_type: 'cpf',
          source_document_number: '',
          value: '0',
          bank_account: null,
          bank_account_id: null
        }
      }
    },
    dialog: {
      type: Boolean,
      default: false
    },
    bankAccountReadOnly: {
      type: Boolean,
      default: false
    }
  },
  data: (vm) => {
    return {
      noDataText: '',
      source_document_type: vm.autocomplete.source_document_type,
      source_document_number: vm.autocomplete.source_document_number,
      source_name: '',
      value: vm.autocomplete.value,
      bank_account_id: null,
      movement_date: utils.currentDate(),
      movement_date_formatted: utils.dbDateToHuman(utils.currentDate()),
      source_bank: '033',
      source_branch: '1142',
      source_account: '130013844',
      source_type: 'PIX',
      spei_reference: '',
      spei_concepto_de_pago: '',
      bankAccounts: [],
      bankAccountItems: [],
      bankAccountsLoaded: 'not_loaded',
      companyLoaded: 'not_loaded',
      loadedCompany: null,
      submitting_data: false,
      currency_config: {
        decimal: ',',
        thousands: '.'
      },
      errors: {}
    }
  },
  watch: {
    dialog (val) {
      if (val == false) {
        this.resetForm()
      } else {
        this.bank_account_id = this.getAutocompleteBankAccountId()
        this.source_document_type = this.autocomplete.source_document_type
        this.source_document_number = ''
        this.value = Number(this.autocomplete.value)
        this.$nextTick(function () {
          this.source_document_number = this.autocomplete.source_document_number
        })
      }
    },
    source_document_number(new_val) {
      this.updateSourceName(new_val)
    },
    movement_date_formatted(new_val) {
      let db_formatted = utils.humanDateToDb(new_val)
      if (utils.isValidDate(db_formatted)) {
        this.movement_date = db_formatted
      } else {
        this.movement_date = ''
      }
    },
    bank_account_id(new_val) {
      let selected_bank_account = this.bankAccounts[this.bankAccounts.findIndex(el => el.id === this.bank_account_id)]
      if(!selected_bank_account) {
        this.source_type = 'WIRE'
        return
      }
      switch (selected_bank_account.currency) {
        case 'BRL':
          this.source_type = 'PIX'
          return;
        case 'MXN':
          this.source_type = 'SPEI'
          return;
        case 'COP':
          this.source_type = 'PSE'
          return;
        case 'CLP':
          this.source_type = 'PCT'
          return;
        default:
          this.source_type = 'WIRE'
          return;
      }
    }
  },
  methods: {
    getAutocompleteBankAccountId() {
      return this.autocomplete.bank_account_id || (this.autocomplete.bank_account && this.autocomplete.bank_account.id) || null
    },
    updateSourceName(document_number) {
      let url = ''
      let mode = 'exact'
      let required_length = 3

      switch(this.source_document_type) {
        case "cpf":
          url = this.$root.urls.admin__search_cpf
          required_length = 11
          break
        case "cnpj":
          url = this.$root.urls.admin__search_cnpj
          required_length = 14
          break
        case "passport":
          url = this.$root.urls.admin__search_passport
          break
        case "tax_id":
          url = this.$root.urls.admin__search_tax_id
          break
        case "curp":
          url = this.$root.urls.admin__search_curp
          mode = 'document_number'
          break
        case "rfc":
          url = this.$root.urls.admin__search
          mode = 'document_number'
          break
        case "cc":
          url = this.$root.urls.admin__search_cc
          mode = 'document_number'
          break
        case "nit":
          url = this.$root.urls.admin__search_nit
          mode = 'document_number'
          break
        case "rut":
          url = this.$root.urls.admin__search_rut
          mode = 'document_number'
          break
      }

      if (url == '') { return }
      if (document_number.length < required_length) { return }

      this.loadCompanyByDocument(url, document_number, mode)
    },
    errorMessagesFor(field) {
      if (this.errors[field]) {
        return this.errors[field]
      } else {
        return []
      }
    },
    loadCompanyByDocument(url, document_number, mode) {
      let successCallback = (response) => {
        if (response.body.data) {
          this.loadedCompany = response.body.data[0]
          if (typeof(this.loadedCompany) === 'undefined') {
            this.loadedCompany = null
            this.$set(this, 'source_name', '')
          } else {
            this.$set(this.errors, 'source_document_number', null)
            this.$set(this, 'source_name', this.loadedCompany.social_name)
          }
          this.companyLoaded = 'ok'
        } else {
          this.loadedCompany = null
          this.companyLoaded = 'error'
          console.log('successCallback', response)
        }
      }

      let errorCallback = (response) => {
        if (response.status === 401) {
          this.companyLoaded = 'not_authorized'
        } else {
          this.companyLoaded = 'error'
        }
        console.log('errorCallback', response)
      }

      let before = (request) => {
        if (this.previousRequest) { this.previousRequest.abort(); }
        this.previousRequest = request;
      }


      let token = this.$cookies.get('api_token')
      let params  = { s: document_number, mode: mode }
      this.$http.get(url, { before, params, headers: { Authorization: `Bearer ${token}` }}).then(successCallback, errorCallback)
    },
    createBankTransaction() {
      if (this.submitting_data) { return }

      let valid = true

      let required_fields = ['source_document_number', 'source_bank', 'source_branch', 'source_account', 'movement_date']
      for (let i in required_fields) {
        let field = required_fields[i]

        if (this[field].trim() == '') {
          this.$set(this.errors, field, ['obrigatório'])
          valid = false
        } else {
          this.$set(this.errors, field, null)
        }
      }

      if (this.companyLoaded == 'ok') {
        if (this.loadedCompany != null) {
          this.$set(this.errors, 'source_document_number', null)
        }
      }

      if (Number(this.value) == 0) {
        this.$set(this.errors, 'value', ['obrigatório'])
        valid = false
      } else {
        this.$set(this.errors, 'value', null)
      }

      if (!!this.bank_account_id) {
        this.$set(this.errors, 'bank_account_id', null)
      } else {
        this.$set(this.errors, 'bank_account_id', ['obrigatório'])
        valid = false
      }

      if (!valid) { return }

      let selected_bank_account = this.bankAccounts[this.bankAccounts.findIndex(el => el.id === this.bank_account_id)]
      if(this.bankAccountReadOnly) {
        selected_bank_account = this.autocomplete.bank_account
      }
      this.$root.$emit('bank_transaction_last_bank_account_id', this.bank_account_id)

      const payload = {
        bank_transaction: {
          bank_account_id: selected_bank_account.id,
          currency: selected_bank_account.currency,
          value: this.value,
          source_document_type: this.source_document_type,
          source_document_number: this.source_document_number,
          source_name: this.source_name,
          movement_date: this.movement_date,
          source_bank: this.source_bank,
          source_branch: this.source_branch,
          source_account: this.source_account,
          source: 'backend',
          source_type: this.source_type,
          source_description: 'CREDITO POR TED',
          spei_reference: this.spei_reference,
          spei_concepto_de_pago: this.spei_concepto_de_pago
        }
      }

      let successCallback = (response) => {
        if (response.body.data) {
          this.$emit('onCreate', response.body.data)
        } else {
          console.log(response)
        }
        this.$emit('closeDialog')
        this.resetForm()
        this.submitting_data = false
      }

      let errorCallback = (response) => {
        this.submitting_data = false

        if (response.body.errors) {
          let errors = response.body.errors

          for (let field in errors) {
            errors[field] = errors[field].map((error_msg)=>{
              return utils.translateErrorMessage(error_msg, this.$root.lang)
            })
          }

          this.errors = errors
        }
      }

      this.errors = {}
      this.submitting_data = true
      const token = this.$cookies.get('api_token')
      this.$http.post(this.$root.urls.admin_bank_transactions, payload, { headers: { Authorization: `Bearer ${token}` }}).then(successCallback, errorCallback)
    },
    findBankAccountByNumberOrNickname(event) {
      let successCallback = (response) => {
        this.bankAccounts = response.body.data
        this.setEmptyTextLabelIfRequired()
        this.bankAccountItems = this.bankAccounts.map(o => { return {text: this.shortAccountName(o), value: o.id} })
        this.bank_account_id = this.getAutocompleteBankAccountId()
        this.bankAccountsLoaded = 'ok'
      }

      let errorCallback = (response) => {
        if (response.status === 401) {
          this.companyLoaded = 'not_authorized'
        } else {
          this.companyLoaded = 'error'
        }
        console.log('errorCallback', response)
      }

      BankAccountsApi.loadBankAccountByNumberOrNickname(this, this.$root.urls.admin__user__bank_accounts, successCallback, errorCallback, event.srcElement.value);
    },
    resetForm() {
      this.source_name = ''
      this.movement_date = utils.currentDate()
      this.movement_date_formatted = utils.dbDateToHuman(utils.currentDate())

      this.source_bank = '033'
      this.source_branch = '1142'
      this.source_account = '130013844'
      this.errors = {}
    },
    setDefaultNoTextLabel() {
      this.noDataText = this.i18n('Digite pelo menos 3 caracteres e tecle enter')
    },
    setEmptyTextLabelIfRequired(){
      if(this.bankAccounts.length == 0) {
        this.noDataText = this.i18n('Nenhum registro encontrado')
      }
    },
    clearAutocomplete(){
      this.bankAccounts = [];
      this.bankAccountItems = [];
      this.bank_account_id = this.getAutocompleteBankAccountId()
      this.setDefaultNoTextLabel()
    },
    i18n(str) {
      return this.$root.l(str)
    },
    shortAccountName(account) {
      let bank_name = account.bank.name
      let account_number = account.account_number
      let nickname = account.nickname && (account.nickname + ' - ') || ''
      if (account_number == '' || account_number === null) { account_number = account.iban }
      return `${nickname}${bank_name} - ${account.currency} - ${account_number}`
    }
  },
  computed: {
    sourceNameDisabled() {
      if (this.companyLoaded == 'ok' && this.loadedCompany == null) { return true }
      return false
    },
    selectedDocumentType() {
      return this.source_document_type
    },
    selectedBankAccount() {
      let bank_account = this.autocomplete.bank_account

      if (bank_account != null && bank_account.bank != null) {
        return bank_account.bank.name + " - " +
        bank_account.bank.code + " - " +
        bank_account.account_number
      } else {
        return null
      }
    }
  },
  mounted() {
    this.setDefaultNoTextLabel()
    this.bank_account_id = this.getAutocompleteBankAccountId()
    this.source_document_type = this.autocomplete.source_document_type
    this.source_document_number = this.autocomplete.source_document_number
    this.value = this.autocomplete.value
  },
  metaInfo: {
    title: "Facilita Pay"
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/BankTransactionAddFormDialog.vue